import api from '../utils/api';

export async function submitLead({ name, email, phone, honeypot = '' }) {
  const { data } = await api.post('/leads', {
    name,
    email,
    phone,
    honeypot,
  });
  return data;
}

export async function verifyLeadCode(leadId, code) {
  const { data } = await api.post(`/leads/${leadId}/verify`, { code });
  return data;
}

export async function verifyLeadToken(token) {
  const { data } = await api.get('/leads/verify-token', {
    params: { token },
  });
  return data;
}

export async function resendLeadCode(leadId) {
  const { data } = await api.post(`/leads/${leadId}/resend`);
  return data;
}
